const fromBookAppointmentMutationToBookedAppointment = (data) => data ? {
  id: data.id,
  isReservation: data.isReservation ?? false,
  startTime: new Date(data.startTime),
  endTime: new Date(data.endTime),
  child: data.child ? {
    firstName: data.child.firstName ?? "",
    lastName: data.child.lastName ?? "",
    dateOfBirth: data.child.dateOfBirth ? new Date(data.child.dateOfBirth) : null
  } : void 0,
  invitee: {
    firstName: data.invitee?.firstName ?? "",
    lastName: data.invitee?.lastName ?? "",
    email: data.invitee?.email ?? "",
    phone: data.invitee?.phone ?? ""
  },
  preferredChannelOfCommunication: data.preferredChannelOfCommunication ?? void 0,
  customerComment: data.customerComment ?? void 0,
  products: data.products?.map((product) => {
    return {
      name: product.displayName,
      price: {
        amount: product.prices?.discountedPrice?.price?.amount ?? product.prices?.originalPrice?.amount,
        currencyCode: product.prices?.discountedPrice?.price?.currencyCode ?? product.prices?.originalPrice?.currencyCode
      },
      image: {
        url: product.media.images[0]?.url ?? ""
      }
    };
  })
} : void 0;
export {
  fromBookAppointmentMutationToBookedAppointment
};
//# sourceMappingURL=fromBookAppointmentMutationToBookedAppointment.js.map
